import rangeSlider from "../vendor/rangeslider-pure/range-slider"
import { getCookie } from "./cookies"

// update position
export default function updateSliderPosition() {
    let sliderAmount = document.querySelectorAll('.slider-amount'),
        sliderMonth = document.querySelectorAll('.slider-month'),
        sliderInterestRee = document.querySelectorAll('.interest .slider-interest'),
        cookieValAmount = getCookie('amount'),
        cookieValMonth = getCookie('months'),
        cookieValInterestDays = getCookie('interestFreeDays'),
        maxAmount = sessionStorage.getItem('maxAmount'),
        maxMonth = sessionStorage.getItem('maxMonth'),
        monthlySteps = sessionStorage.getItem('monthSteps'),
        amountSteps = sessionStorage.getItem('amountSteps');
        

    if (sliderAmount) {
        for (let i = 0; i < sliderAmount.length; i++) {
            sliderAmount[i].rangeSlider.update({
                value: cookieValAmount,
                max: maxAmount,
                step: amountSteps
            });
        }
    }
    if (sliderMonth) {
        for (let i = 0; i < sliderMonth.length; i++) {
            sliderMonth[i].rangeSlider.update({
                value: cookieValMonth,
                max: maxMonth,
                step: monthlySteps
            });
        }
    }

    if (sliderInterestRee && cookieValInterestDays) {
        for (let i = 0; i < sliderInterestRee.length; i++) {
            sliderInterestRee[i].rangeSlider.update({
                value: cookieValInterestDays
            });
        }
    }
}